module.exports = __webpack_public_path__ + "static/hero-hcp-safety-mobile-d173a50cf5c01179ce7b42975f91f81c.png";